import React, {useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';
import {APP_VERSION} from '../services/environments';
import {redirectToOmnicuris} from '../utilities';
import {LogoBig} from '../utilities/resources';
import {useHistory} from 'react-router-dom';
import {isMobile} from 'react-device-detect';

function Footer() {
    const {domainDetails, status} = useSelector((state) => state.listings);
    const footerRef = useRef(null);
    const history = useHistory();

    useEffect(() => {
        window.addEventListener('resize', bodyPadding);
    }, []);

    useEffect(() => {
        bodyPadding();
    }, [footerRef.current]);

    const bodyPadding = () => {
        if (footerRef.current) {
            const body = document.querySelector('body');
            const footer = document.getElementById('footer');
            const footerHeight = footerRef && footerRef.current && footerRef.current.clientHeight;
            if (history.location.pathname.includes('/live')) {
                body.style.paddingBottom = 120 + 'px';
                if (footer !== null && !isMobile) {
                    footer.style.position = 'static';
                }
            } else {
                body.style.paddingBottom = footerHeight + 'px';
                if (footer !== null) {
                    footer.style.position = 'absolute';
                }
            }
        }
    };

    return (
        status === 'success' &&
        (window.location.pathname.includes('/analytics') ? null : (
            <footer ref={footerRef} id='footer'>
                {domainDetails && domainDetails.orgType === 'certifier' && (
                    <section className='footerLinks'>
                        <div className='footerLinksGrid'>
                            <nav>
                                <h4>POWERED BY</h4>
                                <img src={LogoBig} className='section_left_logo' alt='logo'/>
                                <a onClick={() => redirectToOmnicuris('/about-us')}>About Omnicuris</a>
                                <a onClick={() => redirectToOmnicuris('/contact-us')}>Contact Omnicuris</a>
                            </nav>
                            <nav>
                                <h4>SUPPORT</h4>
                                <a onClick={() => redirectToOmnicuris('/faq')}>Help & FAQ</a>
                                <a onClick={() => redirectToOmnicuris('/privacy-policy')}>Privacy Policy</a>
                                <a onClick={() => redirectToOmnicuris('/terms-of-use')}>Terms of Use</a>
                            </nav>
                        </div>
                        {/* <ul className='social-connect'>
              <li>
                <a href=''>
                  <img src={FacebookIcon} alt='' />
                </a>
              </li>
              <li>
                <a href=''>
                  <img src={TwitterIcon} alt='' />
                </a>
              </li>
              <li>
                <a href=''>
                  <img src={InstagramIcon} alt='' />
                </a>
              </li>
              <li>
                <a href=''>
                  <img src={LinkedinIcon} alt='' />
                </a>
              </li>
            </ul> */}
                    </section>
                )}
                <section className='copyrightGrid'
                         style={{borderTop: domainDetails.orgType === 'industry_partner' ? 'none' : ''}}>
                    {domainDetails.orgType === 'industry_partner' && (
                        <div id='logo' style={{marginLeft: 0, marginBottom: 10}}>
                            <img src={domainDetails.image} alt='logo' style={{height: 36}}/>
                        </div>
                    )}
                    <div className={`footerBottom ${domainDetails.orgType === 'certifier' ? 'footerBottomExt' : ''}`}>
                        <span>Copyright © {new Date().getFullYear()}-{new Date().getFullYear() + 1} All Rights Reserved.</span>
                        <span>v{APP_VERSION}</span>
                    </div>
                </section>
            </footer>
        ))
    );
}

export default Footer;
